export const MONEYKIT_CONNECT_FRAME_ID = 'moneykit-connect-frame';

export function fitMoneykitConnectFrameToViewport() {
  const frame = document.getElementById(MONEYKIT_CONNECT_FRAME_ID);
  if (frame instanceof HTMLIFrameElement) {
    frame.style.width = '100%';
  }
}
